export { default as ViewAssetHistoryModal } from "./view-asset-history-modal.vue";

export * from "./IAssetHistoryModal";